<template>
    <div class="releaseSearch" ref='banner'>
        <header-top :goBack="true" :mine='true'></header-top>
        <p class="addtext" ref='title'>{{$t('releaseSearch.report')}}</p>
        <div class="main" ref='wrapper'>
            <div id="scrollBox" style="height:700px;">
                <div class="title" v-if="false">
                    <el-input v-model="title" :placeholder="$t('releaseSearch.title')" @change="Verificationtitle" maxlength='20'></el-input>
                    <span class="danger" v-show="flag">{{$t('releaseSearch.nottitle')}}</span>
                    <span class="danger" v-show='flag6'>{{$t('addpet.flag2')}}</span>
                </div>
                <div class="describe">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4}" maxlength='200' :placeholder="$t('releaseSearch.decription')" v-model="textarea2" @change='Verificationtext' @input='word'>
                    </el-input>
                    <span class="danger" v-show="flag1">{{$t('releaseSearch.notneed')}}</span>
                    <span class="wordlimit">{{num}}/200</span>
                </div>
                <div class="time">
                    <p>{{$t('releaseSearch.losttime')}}</p>
                    <div class="block">
                        <el-date-picker v-model="losttime" type="date" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('releaseSearch.choicetime')" :picker-options="pickerOptions" @focus='disapper' ref='datetime' @change='vertime'>
                        </el-date-picker>
                    </div>
                    <span class="danger" v-show="flag2" style="margin-left:20px;">{{$t('releaseSearch.nottime')}}</span>
                </div>
                <div class="loseplace">
                    <p>{{$t('releaseSearch.lostadr')}}</p>
                    <p @click="changeplace">{{place}}</p>
                </div>

                <div style="margin-top:15px;display:none;">
                    <div id="allmap" style="width: 90%;height:200px;border: 1px solid gray;overflow:hidden;margin:10px auto;"></div>
                </div>
                <div class="selectpet">
                    <p>{{$t('releaseSearch.choicepet')}}</p>
                    <img :src="imgchoose?avatar1:petimg" @click="selectpet" />
                </div>
                <div class="petphoto">
                    <p>{{$t('releaseSearch.petImg')}}</p>
                    <span v-if="imgflag" @click="removeimg"><img src='../../image/delete.png' class="delete" /></span>
                    <img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg" v-show="isshow" />
                    <canvas ref="can" v-show="showflag" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
                    <input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />
                    <span v-if="imgflag1" @click="removeimg1"><img src='../../image/delete.png' class="delete1" /></span>
                    <img :src="imgflag1?avatar2:avatar1" @click.stop="uploadHeadImg1" v-show="isshow1" />
                    <canvas ref="can1" v-show="showflag1" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
                    <input type="file" accept="image/*" @change="handleFile1" class="hiddenInput1" />
                    <span v-if="imgflag2" @click="removeimg2"><img src='../../image/delete.png' class="delete2" /></span>
                    <img :src="imgflag2?avatar3:avatar1" @click.stop="uploadHeadImg2" v-show="isshow2" />
                    <canvas ref="can2" v-show="showflag2" style="width: 60px;height: 60px;margin-left: 20px;"></canvas>
                    <input type="file" accept="image/*" @change="handleFile2" class="hiddenInput2" />
                </div>
                <div class="info">
                    <span>{{$t('releaseSearch.opencontact')}}</span>
                    <el-select v-model="value" :placeholder="$t('releaseSearch.choice')" size="small" style="width:140px;" @change='contact' @focus="isinfo" @visible-change="leinfo" ref='info'>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <p class="danger" v-show="flag3" style="margin-left:20px;">{{$t('releaseSearch.notcontact')}}</p>
                </div>
                <el-button type="primary" style='margin:20px auto;display: block;width: 80%;' @click='release' :disabled='issub'>{{$t('mysearch.publishFind')}}</el-button>
            </div>
        </div>
        <v-choosePet ref='banner' :choose='choose' :addBtn='false' :isShow='isShow' v-on:listen-isShow="listenIsShow" @pet='pet'></v-choosePet>
        <mapinfo ref='bannerto' @adress='adress'></mapinfo>
    </div>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import { addPublish, getPetDevices } from "../../ClientServerApi/index.js";
import { getLoginUser } from "../../api/index.js";
import Qs from "qs";
import headerTop from "../../components/header";
import BMap from "BMap";
import choosePet from "../../components/choosePet";
import EXIF from "exif-js/exif.js";
import mapinfo from "../myAccount/mapinfo";
export default {
    name: "releaseSearch",
    data() {
        return {
            title: "",
            losttime: "",
            num: 0,
            avatar: "",
            avatar1: require("../../image/addphoto.png"),
            avatar2: "",
            avatar3: "",
            imgflag: false,
            imgflag1: false,
            imgflag2: false,
            imgchoose: true,
            showflag: false,
            showflag1: false,
            showflag2: false,
            isshow: true,
            isshow1: true,
            isshow2: true,
            petimg: require("../../image/addphoto.png"),
            msg: this.$t("addpet.trueAdd"),
            tmsg: this.$t("addpet.trueAdd"),
            cmsg: this.$t("addpet.submiting"),
            issub: false,
            id: "",
            lat: "",
            lng: "",
            mobile: "",
            email: "",
            address: "",
            nickname: "",
            personinfo: "",
            featurePhoto: [],
            textarea2: "",
            value: "",
            options: [
                {
                    value: "1",
                    label: this.$t("prompt.openemail")
                },
                {
                    value: "2",
                    label: this.$t("prompt.openphone")
                },
                {
                    value: "3",
                    label: this.$t("prompt.openall")
                }
            ],
            isShow: false,
            choose: "",
            place: "",
            flag: false,
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: true,
            flag5: false,
            flag6: false,
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > Date.now();
                }
            },
            scrollY:0
        };
    },
    components: {
        "v-choosePet": choosePet,
        mapinfo,
        headerTop
    },
    mounted() {
        this.$refs.wrapper.style.top =
        this.$refs.title.offsetHeight + 40 + "px";
        this.$nextTick(() => {
           this._initScroll()
        });
        getLoginUser()
            .then(res => {
                console.log(res);
                this.personinfo = res.data.data;
            })
            .catch(error => {
                console.log(error);
            });
        this.ready();
        let windowHeigt =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
    },
    created() {
        if (this.$route.query.portrait) {
            this.petimg = this.$route.query.portrait;
            this.id = this.$route.query.petId;
            this.imgchoose = false;
        }
        //检验是否登录超时
        if (sessionStorage.getItem("login") == 1) {
        getLoginUser()
            .then(res => {
            if (res.data.header.status == 3019) {
                sessionStorage.setItem("login", "1");
                this.$message({
                type: "success",
                message: this.$t("prompt.header")
                });
                this.$router.push("/login");
            }
            })
            .catch(err => {});
        }
    },
    methods: {
       _initScroll(){
            this.Scroll = new IScroll(this.$refs.wrapper, {
                click: true,
                probeType: 3
            });
            let self = this
            this.Scroll.on('scroll',function(){
                self.scrollY = this.y
            },true)
        },
        //定位
        ready: function() {
            var th = this;
            var map = new BMap.Map("allmap");
            var geolocation = new BMap.Geolocation();
            var geoc = new BMap.Geocoder();
            geolocation.getCurrentPosition(
                function(r) {
                    if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                        th.lng = r.point.lng;
                        th.lat = r.point.lat;
                        geoc.getLocation(r.point, function(rs) {
                            //addressComponents对象可以获取到详细的地址信息
                            var addComp = rs.addressComponents;
                            var site =
                                addComp.province +
                                addComp.city +
                                addComp.district +
                                addComp.street +
                                addComp.streetNumber;
                            th.place = site;
                        });
                    } else {
                        alert("failed" + this.getStatus());
                    }
                },
                { enableHighAccuracy: true }
            );
        },
        Verificationtitle() {
            if (this.title.length == 0) {
                this.flag6 = false;
            } else {
                this.flag = false;
            }
        },
        Verificationtext() {
            if (this.textarea2.length > 0) {
                this.flag1 = false;
            }
        },
        word() {
            this.num = this.textarea2.length;
        },
        adress(data) {
            if (data != "") {
                this.place = data;
            }
        },
        changeplace() {
            this.$refs.bannerto.show();
        },
        isinfo(){
            this.Scroll.destroy()
        },
        leinfo(e){
            if(e==false){
            this._initScroll()
            this.Scroll.scrollTo(0, this.scrollY)
            this.$refs.info.blur()
            }
        },
        // 打开图片上传
        uploadHeadImg: function(e) {
            if (this.imgflag == false) {
                this.$el.querySelector(".hiddenInput").click();
            }
        },
        // 将头像显示
        handleFile: function(e) {
            this.flag5 = false;
            var th = this;
            th.imgflag = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag = false;
                    th.isshow = true;
                    th.avatar = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress(res.result, Orientation);
                }
            };
        },
        compress(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag = true;
            th.isshow = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                var canvas = th.$refs.can;
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar = base64.result;
            };
        },
        compress1(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag1 = true;
            th.isshow1 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can1;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar2 = base64.result;
            };
        },
        compress2(result, Orientation) {
            var img = new Image();
            var th = this;
            img.src = result;
            th.showflag2 = true;
            th.isshow2 = false;
            img.onload = function() {
                var width = img.width;
                var height = img.height;
                var canvas = th.$refs.can2;
                var ratio = 400;
                if (width > ratio) {
                    var scaling = 1 - (width - ratio) / width;
                    width = width * scaling;
                    height = height * scaling;
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                if (
                    Orientation != "" &&
                    Orientation != 1 &&
                    Orientation != undefined
                ) {
                    switch (Orientation) {
                        case 6: //需要顺时针（向左）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, width, -height);
                            break;
                        case 8: //需要逆时针（向右）90度旋转
                            canvas.width = height;
                            canvas.height = width;
                            ctx.rotate((-90 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, 0);
                            break;
                        case 3: //需要180度旋转
                            ctx.rotate((180 * Math.PI) / 180);
                            ctx.drawImage(img, 0, 0, -width, -height);
                            break;
                    }
                } else {
                    canvas.getContext("2d").drawImage(img, 0, 0, width, height);
                }
                var base64 = canvas.toDataURL("image/jpeg", 0.15);
                th.featurePhoto.push(base64.split(",")[1]);
                th.avatar3 = base64.result;
            };
        },
        // 打开图片上传
        uploadHeadImg1: function() {
            if (this.imgflag1 == false) {
                this.$el.querySelector(".hiddenInput1").click();
            }
        },
        // 将头像显示
        handleFile1: function(e) {
            this.flag5 = false;
            var th = this;
            this.imgflag1 = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag1 = false;
                    th.isshow1 = true;
                    th.avatar2 = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress1(res.result, Orientation);
                }
            };
        },
        // 打开图片上传
        uploadHeadImg2: function() {
            if (this.imgflag2 == false) {
                this.$el.querySelector(".hiddenInput2").click();
            }
        },
        // 将头像显示
        handleFile2: function(e) {
            this.flag5 = false;
            var th = this;
            this.imgflag2 = true;
            let $target = e.target || e.srcElement;
            let file = $target.files[0];
            let maxSize = 400 * 1024;
            var reader = new FileReader();
            let Orientation;
            EXIF.getData(file, function() {
                Orientation = EXIF.getTag(this, "Orientation");
            });
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = data => {
                let res = data.target || data.srcElement;
                if (data.total < maxSize) {
                    th.showflag2 = false;
                    th.isshow2 = true;
                    th.avatar3 = res.result;
                    th.featurePhoto.push(data.target.result.split(",")[1]);
                } else {
                    th.compress2(res.result, Orientation);
                }
            };
        },
        disapper() {
            this.$refs.datetime.blur();
        },
        vertime() {
            if (this.losttime.length > 0) {
                this.flag2 = false;
            }
        },
        //选择宠物
        selectpet() {
            this.isShow = true;
        },
        petid(data) {
            this.id = data;
            // console.log(this.id);
        },
        listenIsShow(data) {
            //监听获得子组件choosePet传来的关闭信息值
            this.isShow = data;
            this.imgchoose = data;
        },
        pet(data) {
            //获取选取的宠物头像
            this.petimg = data.portrait;
            this.id = data.id;
        },
        //删除已选的照片
        removeimg() {
            this.imgflag = false;
            this.showflag = false;
            this.isshow = true;
            this.featurePhoto.splice(0, 1);
        },
        removeimg1() {
            this.imgflag1 = false;
            this.showflag1 = false;
            this.isshow1 = true;
            if(this.featurePhoto.length>=2){
                this.featurePhoto.splice(1, 1);
            }else{
                this.featurePhoto.splice(0,1)
            }
        },
        removeimg2() {
            this.imgflag2 = false;
            this.showflag2 = false;
            this.isshow2 = true;
            if(this.featurePhoto.length==3){
                this.featurePhoto.splice(2, 1);
            }else if(this.featurePhoto.length==2){
                this.featurePhoto.splice(1, 1);
            }else{
                this.featurePhoto.splice(0,1)
            }
        },
        contact(e) {
            // console.log(e);
            if (e == 1) {
                this.mobile = "";
                this.flag4 = false;
                if (this.personinfo.email) {
                    this.email = this.personinfo.email;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
            if (e == 2) {
                this.email = "";
                this.flag4 = false;
                if (this.personinfo.mobile) {
                    this.mobile = this.personinfo.mobile;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
            if (e == 3) {
                this.flag4 = false;
                if (this.personinfo.mobile && this.personinfo.email) {
                    this.email = this.personinfo.email;
                    this.mobile = this.personinfo.mobile;
                    this.flag3 = false;
                } else {
                    this.flag3 = true;
                }
            }
        },
        release() {
            if (this.textarea2.length == 0) {
                this.flag1 = true;
            } else {
                this.flag1 = false;
            }
            if (this.losttime.length == 0) {
                this.flag2 = true;
            } else {
                this.flag2 = false;
            }
            if (this.imgchoose == true) {
                this.$message({
                    type: "warning",
                    message: this.$t("prompt.notChoicePet")
                });
            }
            if (this.flag4 == true) {
                this.$message({
                    type: "warning",
                    message: this.$t("prompt.notChoiceConcact")
                });
            }
            if (this.featurePhoto.length == 0) {
                this.flag5 = true;
                this.$message({
                    type: "warning",
                    message: this.$t("prompt.notChoiceImg")
                });
            }
            let params = Qs.stringify({ petId: this.id });
            getPetDevices(params)
                .then(res => {
                    // console.log('this1',res);
                    // console.log('this',res.data.header.status);
                    if (res.data.header.status == 1000) {
                        this.msg = this.cmsg;
                        setTimeout(() => {
                            //console.log( this.flag, this.flag1,this.flag2,this.imgchoose, this.flag4, this.flag5)
                            this.msg = this.tmsg;
                            if (
                                this.flag1 == false &&
                                this.flag2 == false &&
                                this.imgchoose == false &&
                                this.flag3 == false &&
                                this.flag4 == false &&
                                this.flag5 == false
                            ) {
                                let params = Qs.stringify({
                                    title: this.title,
                                    content: this.textarea2,
                                    lat: this.lat,
                                    lon: this.lng,
                                    loseTime: this.losttime,
                                    lostPlace: this.place,
                                    featurePhoto: JSON.stringify(
                                        this.featurePhoto
                                    ),
                                    petId: this.id,
                                    mobile: this.mobile,
                                    email: this.email,
                                    bounty: ""
                                });
                                addPublish(params)
                                    .then(res => {
                                        // console.log(res);
                                        this.issub = true;
                                        if (res.data.header.status == 1000) {
                                            this.$router.push({
                                                path: "/mysearch"
                                            });
                                            sessionStorage.removeItem("base");
                                        } else if (
                                            res.data.header.status == 81011
                                        ) {
                                            this.$message({
                                                type: "warning",
                                                message: this.$t("prompt.found")
                                            });
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    });
                            }
                        }, 300);
                    } else if(res.data.header.status=='80002'){
                        
                        this.$message({
                            type: "error",
                            message: this.$t("prompt.notdevice")
                        });
                    }
                })

                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.title .el-input__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.title .el-input__inner:hover {
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.releaseSearch .el-textarea__inner {
    font-size: 0.75rem;
    border-top-color: white;
    border-right-color: white;
    border-left-color: white;
}
.releaseSearch .el-button--primary {
    width: 72%;
    margin-left: 14%;
    font-size: 1rem;
    height: 2.6rem;
    line-height: 2.6rem;
    color: rgb(255,255,255);
    margin-top: 30px;
    border-radius: 1.3rem;
    background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
    border: 0;
    padding: 0 0;
}
.releaseSearch .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    margin-left: 20px;
}
</style>
<style scoped>
.main{
    margin-top: 20px;
}
.addtext {
    text-align: center;
    padding: 20px 0;
    font-size: 1rem;
    color: rgb(130, 130, 130);
    letter-spacing: 1px;
}
.releaseSearch .danger {
    font-size: 0.625rem;
    color: red;
    margin-top: 5px;
}
.title {
    margin-top: 15px;
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
}
.describe {
    width: 90%;
    margin: 0 auto;
}
.time p {
    font-size: 0.875rem;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.wordlimit {
    font-size: 0.625rem;
    position: absolute;
    right: 20px;
}
.loseplace {
    border-bottom: solid 1px rgb(230, 230, 230);
}
.loseplace p {
    font-size: 0.875rem;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.loseplace p:nth-child(2) {
    font-size: 0.75rem;
    margin-left: 20px;
    margin-top: 15px;
    margin-bottom: 10px;
}
.selectpet p {
    font-size: 0.875rem;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.petphoto .delete {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 20px;
    left: -5px;
}
.petphoto .delete1 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 20px;
    left: 78px;
}
.petphoto .delete2 {
    position: absolute;
    width: 15px;
    height: 15px;
    top: 20px;
    left: 163px;
}
.selectpet img {
    width: 60px;
    height: 60px;
    margin-left: 20px;
}
.petphoto {
    border-bottom: solid 1px rgb(230, 230, 230);
    padding-bottom: 10px;
    position: relative;
}
.petphoto p {
    font-size: 0.875rem;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.petphoto img {
    object-fit:cover;
    width: 60px;
    height: 60px;
    margin-left: 20px;
}
.info {
    margin: 15px 0;
}
.info span {
    font-size: 0.875rem;
    margin-left: 20px;
}
.el-message {
    width: 80%;
}
.head_img img {
    width: 60px;
    height: 60px;
}
.hiddenInput {
    display: none;
}
.hiddenInput1 {
    display: none;
}
.hiddenInput2 {
    display: none;
}
.main {
    position: absolute;
    top: 55px;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    touch-action: none;
}
</style>


// WEBPACK FOOTER //
// src/m_page/finder/releaseSearch.vue